export default "__VITE_ASSET__BYipxouN__"